import React from "react";
import { Text } from "@RooUI";

import { useRegistrationContext } from "../Common/registrationContext";

import { useIsLicenseRequired } from "./service";

export const RegistrationTechLicenseFormText = () => {
  const isLicenseRequired = useIsLicenseRequired();
  const {
    registrationContext: { stateName },
  } = useRegistrationContext();

  if (!stateName) {
    return (
      <Text>
        <b>(Optional) </b>Please enter your license information. You will be able to access even
        more shifts if you have additional credentials.
      </Text>
    );
  } else if (isLicenseRequired) {
    return (
      <Text>
        <b>In order to work in your area</b> you have to provide a <b>{stateName}</b> state license
        number.
      </Text>
    );
  } else {
    return (
      <Text>
        <b>You can pick up shifts in your area</b> since <b>{stateName}</b> does not require a
        technician license. However, you will be able to access even more shifts if you have
        additional credentials.
      </Text>
    );
  }
};
